import cn from 'classnames'
import type {ReactNode} from 'react'
import type {IconType} from 'src/common/Icon'
import {ContentCard} from './ContentCard'
import {IconBadge} from './IconBadge'

export type FactCardProps = {
  icon: IconType
  label?: string
  value: string
  detail?: string
  row?: boolean
  action?: ReactNode
}

export const FactCard = ({icon, label, value, detail, row = false, action}: FactCardProps) => (
  <ContentCard row={row}>
    <IconBadge icon={icon} size={row ? 's' : 'm'} />
    <div className={cn('flex min-w-0 flex-col', !row && 'mt-3')}>
      {label && <span className="mb-3 text-[11px] uppercase tracking-[0.05em] text-green-mist-dim">{label}</span>}
      <span className={cn('break-words font-bold leading-tight', row ? 'text-14' : 'text-18')}>{value}</span>
      {detail && <span className="mt-1 text-13 text-green-mist-dim">{detail}</span>}
    </div>
    {action && <div className="mt-auto pt-5">{action}</div>}
  </ContentCard>
)
